export default __webpack_public_path__ + "static/media/jsC.ce4dee9a.webp";